import { useState, useEffect } from "react";
import { AddIcon, RemoveIcon } from "@fluentui/react-icons-mdl2";
import CRMStatusCard from "./CRMStatusCard";

const CRMStatusTracker = ({ title, active, stage }) => {
  const [collapse, setCollapse] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    if (isUpdating) {
    }
  }, [isUpdating]);

  return (
    <div className="crm-card" key={title}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          padding: 10,
        }}
      >
        <div
          className="crm-journal-header centered-row"
          onClick={(e) => {
            e.preventDefault();
            setCollapse(!collapse);
          }}
        >
          {title}
        </div>
        <div
          onClick={(e) => {
            e.preventDefault();
            setCollapse(!collapse);
          }}
          style={{
            display: "flex",
            alignSelf: "flex-end",
            paddingBottom: 35,
            fontSize: 12,
          }}
        >
          {collapse ? <AddIcon /> : <RemoveIcon />}
        </div>
      </div>
      {!collapse && (
        <div className="crm-card-content">
          {active === undefined ? (
            <div style={{ textAlign: "center" }}>
              Select a lead to update its status.
            </div>
          ) : (
            <CRMStatusCard
              stage={stage}
              j={active}
              status={JSON.parse(active.status)}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default CRMStatusTracker;
